import { Component, OnInit } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { UserSystemPreference } from '../../models/userSystemPreference';
import { ConstraintsModel, dateConstraints, dateMatchModes, GridColumnHeader, MatchModeOptionsModel, textNumberConstraints, textNumberMatchModes } from '../../models/grid-column-header';
import { WorkItem } from '../../models/work-item';
import { MyWorkBasketService } from './my-work-basket.service';
import * as XLSX from 'xlsx';
import { SaveColumnsReorder } from '../../models/save-Columns-Reorder';
import { GlobalService } from '../../services/global.service';
import { ReAssignReleaseDto } from '../../models/reAssignReleaseDto';
import { UserReassignComponent } from '../../shared/user-reassign/user-reassign.component';
import { MatDialog } from '@angular/material/dialog';
import { DocInfo } from '../../models/documentInfoDto';
import { SendEmailComponent } from '../../shared/send-email/send-email.component';
import { RetrievalService } from '../retrieval/retrieval.service';
import { WorkflowHistoryResponse } from '../../models/workflow-history.model';
import { WorkflowHistoryDialogComponent } from '../../shared/workflow-history-dialog/workflow-history-dialog.component';
import { DocumentHistoryDialogComponent } from '../../shared/document-history-dialog/document-history-dialog.component';
import { DocumentHistoryResponse } from '../../models/document-history.model';
import { ViewAddDocNotesComponent } from '../../shared/view-add-doc-notes/view-add-doc-notes.component';
import { ViewWorkflowNotesComponent } from '../../shared/view-workflow-notes/view-workflow-notes.component';
import { AppContext } from '../../models/appContext';
import { LineItemsGlEntryComponent } from '../../shared/line-items-gl-entry/line-items-gl-entry.component';
import { BusinessArea } from '../../models/model';
import { environment } from '../../../environments/environment';
import { DateService } from '../../services/date.service';

@Component({
  selector: 'app-my-work-basket',
  templateUrl: './my-work-basket.component.html',
  styleUrl: './my-work-basket.component.scss',
})
export class MyWorkBasketComponent implements OnInit {

  public name$!: Observable<string>;

  adminEmitter: any = {
    alter: "alter",
    reAssign: "re-assign",
    releaseStatus: "The selected work Item is already Released",
    apiCallSuccess: "Changes has been Updated",
    Suspend: "Suspend",
    Active: "Active",
  };
  public gridData!: any[];
  public pageSize = 10;
  public skip = 0;
  public columnHeaderArray: GridColumnHeader[] = [];
  public selectedSystemId: any | undefined;
  userSystemPreferencedata!: UserSystemPreference[];
  public selectedDateFormat!: string | null;
  public datePreferenceEnglish: boolean = false;
  public datePreferenceRussian: boolean = false;
  public datePreference!: string | null;
  public savedGridColumnOptions!: GridColumnHeader[];
  public workItems: WorkItem[] = [];
  public data: WorkItem[] = [];
  public columns: GridColumnHeader[] = [];
  public selectedWorkItems: WorkItem[] = [];
  dragSelecting = false;
  selectedIndexes: number[] = [];
  public dateformat!: string;
  public isDataAvailable: boolean = true;
  public saveColumnReorderDto: any;
  public gridOption: any;
  documentInfo: DocInfo[] = [];
  isDocumentNotesDisable: boolean = true;
  isWorkflowNotesDisable: boolean = true;
  isDocumentHistoryDisable: boolean = true;
  isWorkflowHistoryDisable: boolean = true;
  isLinkDisable: boolean = true;
  isEmailDisable: boolean = true;
  isPrintDisable: boolean = true;
  isReAssignDisable: boolean = true;
  isReleaseDisable: boolean = true;
  isTableLoading: boolean = true;
  public gridDataSource: any;
  private intervalId: any;
  // Filtering 1 for ascending, -1 for descending
  sortField: string = "";
  sortOrder: number = 1;
  filters: { [key: string]: any } = {};
  selectedBusinessArea: any;
  userPreferedDateformat!:string |null;
  userPreferedDateTimeformat!:string |null;
  constructor (
    private readonly commonService: CommonService,
    private readonly workItemService: MyWorkBasketService,
    private readonly globalVariable: GlobalService,
    private readonly retrievalService: RetrievalService,
    private readonly dialog: MatDialog,
    private readonly dateService:DateService
  ) { }

  async ngOnInit() {
    this.commonService.clearMessage();
    if (this.selectedSystemId == 0 || this.selectedSystemId == undefined) {
      this.selectedSystemId = this.globalVariable.getSelectedSystemId;
    }
    AppContext.userDetails = this.globalVariable.getUserDetails;
    await this.callRegisterPrincipal(Number(this.selectedSystemId));
    this.getBusinessAreas().then(() => {
      this.getGridColumnHeaders();
    });
    this.getUserPreferences();
    this.intervalId = setInterval(() => this.checkWorkbasketRefreshFlag(), 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  checkWorkbasketRefreshFlag(): void {
    if (localStorage.getItem('workbasketDocViewer')) {
      localStorage.removeItem('workbasketDocViewer');
      this.refreshWorkItem();
    }
  }

  // Function to get the business areas
  async getBusinessAreas(): Promise<void> {
    try {
      const response: BusinessArea[] = await firstValueFrom(
        this.retrievalService.getBusinessAreaList(this.globalVariable.getUserGPID,this.globalVariable.getSelectedSystemId)
      );
      this.selectedBusinessArea = response[0]?.id;
    } catch (error) {
      console.error('Not able to fetch the bussiness area');
    }
  }

  callRegisterPrincipal(systemId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.commonService.callRegisterPrincipal(systemId).subscribe({
        next: (response) => {
          resolve();
        },
        error: (error) => {
          this.commonService.openErrorDialog(error.error.message);
          this.commonService.showMessage('User registration failed', 'error');
          reject(error);
        }
      });
    });
  }


  async getMyWorkItemBasketDetails(): Promise<void> {
    this.isTableLoading = true;
    (await this.workItemService.getMyWorkItemBasketDetails()).subscribe({
      next: (response) => {
        this.isDataAvailable = response.workItems.length > 0 ? true : false;
        const dataWorkItems = response.workItems.length > 0 ? this.processWorkItemData(response.workItems) : response.workItems;
        this.workItems = dataWorkItems;
        this.data = dataWorkItems;
        this.generateFilters();
        this.customFilter();
        this.isTableLoading = false;
      },
      error: (error) => {
        this.isDataAvailable = false;
        this.isTableLoading = true;
      }
    });
  }

  processWorkItemData(WorkItems: any): WorkItem[] {
    WorkItems.forEach((item: WorkItem) => {
      item.view_Document = `/documentViewer/${item.QueueId}/${item.DocumentId}/${item.InstanceId}/001/${item.BatchId}`;
      for (const key in item) {
        if ( key.includes('DATE') || key === 'CreateDate' ) {
          if(key == 'INVOICE_DATE'){
            item[key] = item[key] ? this.dateService.formatDateValue(item[key], this.userPreferedDateformat): '';
          } else { 
            item[key] = item[key] ? this.dateService.formatDateValue(item[key], this.userPreferedDateTimeformat): '';
          }
        }
      }
    });
    return WorkItems;
  }

  generateFilters(): void {
    this.columns.forEach(column => {
      if (column.type == 'date') {
        column.filterOptions = [
          { label: 'Past 7 days', value: '7' },
          { label: 'Past 14 days', value: '14' },
          { label: 'Past 1 month', value: '30' },
          { label: 'Past 2 months', value: '60' },
          { label: 'Past 3 months', value: '90' },
          { label: 'Past 6 months', value: '182' },
          { label: 'Last year', value: '365' },
          { label: 'All', value: 'All' }
        ];
        column.selectedValues = [];
      } else {
        const values = new Set<string>();
        this.data.forEach(record => {
          const propertyName: keyof WorkItem = column.field as keyof WorkItem;
          values.add(record[propertyName]);
        });
        column.filterOptions = Array.from(values).map(v => ({ label: v, value: v }));
        column.selectedValues = [];
      }
    });
 
    Object.keys(this.filters).forEach(field => {
      const allFilterValues = this.columns.find(item => item.field == field)!.filterOptions.map(opt => opt.value);
      const value = this.filters[field];
      const isExists = value.some((val: any) => allFilterValues.includes(val));
      if (!isExists) {
        delete this.filters[field];
      }
    });
  }

  getUserPreferences(): void {
    this.commonService.getUserPerferences().subscribe({
      next: (response: UserSystemPreference[]) => {
        this.userSystemPreferencedata = response;
        this.globalVariable.setUserPreferences = response;
        this.userSystemPreferencedata.forEach((element) => {
          if (element.preferenceTitle == "Date Format Display") {
            this.selectedDateFormat = element.preferenceValue;
            this.datePreferenceEnglish = this.selectedDateFormat == "English";
            this.datePreferenceRussian = this.selectedDateFormat == "Russian";            
            this.userPreferedDateTimeformat = element.dateFormatOptions[0].defaultFormat;
            this.userPreferedDateformat = element.dateFormatOptions[0].defaultFormat.split(' ')[0];
            this.datePreference = localStorage.getItem("setDatePreference");
            if (!this.datePreference) {
              this.datePreference = "English";
            }
            if (this.selectedSystemId == element.systemId) {
              if (this.datePreference == element.preferenceValue) {
                element.dateFormatOptions.forEach(dateformatType => {
                  if (dateformatType.language == this.datePreference) {
                    this.dateformat = dateformatType.defaultFormat;
                  }
                });
              }
            }
          }
          else if (element.preferenceTitle == "Routing in Workflow") {
            if (element.preferenceValue == "true") {
              localStorage.setItem("setUserPerferenceRoutingButton", "button");
            } else {
              localStorage.setItem("setUserPerferenceRoutingButton", "select");
            }
          }
        });
      },
      error: (error) => {
        this.commonService.showMessage("Error in loading user preferences.", 'error');
      }
    });
  }

  getGridColumnHeaders(): void {
    this.commonService.getGridColumnHeaders(1, this.selectedBusinessArea, 0, 0, this.selectedSystemId).subscribe({
      next: (response) => {
        this.columnHeaderArray = response.map((column) => {
            let matchModeOptionslist: MatchModeOptionsModel[] = [];
            let constraintslist: ConstraintsModel[] = [];
            switch (column.type) {
              case 'string':
              case 'number':
                matchModeOptionslist = [...textNumberMatchModes];
                constraintslist = textNumberConstraints.map(c => ({ ...c }));
                break;
              case 'date':
                matchModeOptionslist = [...dateMatchModes];
                constraintslist = dateConstraints.map(c => ({ ...c }));
                break;
              default:
                matchModeOptionslist = [];
                constraintslist = [];
            }
            return {
              ...column,
              advancefilter: {
                matchModeOptions: matchModeOptionslist,
                operator: 'and',
                constraints: constraintslist,
                isAdvanceFilterUsed: false,
              }
            }
          });
        [...this.columns].sort((a, b) => a.order - b.order);
        this.columns = this.columnHeaderArray;
        this.getMyWorkItemBasketDetails();
      },
      error: (error) => { }
    });
  }

  customFilter(value?: any): void {
    this.selectedIndexes = [];
    this.syncSelectedWorkItems();
    let filteredData = [...this.data];
        if (Object.keys(this.filters).length) {
          Object.keys(this.filters).forEach((field) => {
            const selectedValues = this.filters[field];
            if (!selectedValues || selectedValues.length === 0)
              return;
    
            if (value === 'date') {
              if (selectedValues.includes('All'))
                return;
    
              const today = new Date();
              filteredData = filteredData.filter((workItem) => {
                const rawValue = workItem[field as keyof WorkItem];
                if (!rawValue)
                  return false;
    
                const itemDate = this.parseCustomDate(rawValue);
    
                if (!itemDate)
                  return false;
    
                if (isNaN(itemDate.getTime()))
                  return false;
    
                return selectedValues.some((selectedRange: any) => {
                  if (selectedRange === '365') {
                    const start = new Date(today.getFullYear() - 1, 0, 1);
                    const end = new Date(today.getFullYear(), 0, 1);
                    return itemDate >= start && itemDate < end;
                  }
    
                  let filterDate = new Date(today);
                  switch (selectedRange) {
                    case '7':
                      filterDate.setDate(today.getDate() - 7);
                      break;
                    case '14':
                      filterDate.setDate(today.getDate() - 14);
                      break;
                    case '30':
                      filterDate.setMonth(today.getMonth() - 1);
                      break;
                    case '60':
                      filterDate.setMonth(today.getMonth() - 2);
                      break;
                    case '90':
                      filterDate.setMonth(today.getMonth() - 3);
                      break;
                    case '182':
                      filterDate.setMonth(today.getMonth() - 6);
                      break;
                    default:
                      return false;
                  }
                  return itemDate >= filterDate;
                });
              });
            } else {
              const propertyName: keyof WorkItem = field as keyof WorkItem;
              filteredData = filteredData.filter((workItem) => selectedValues.includes(workItem[propertyName]));
            }
          });
        }
    this.workItems = filteredData;
  }

  parseCustomDate(dateString: string): Date | null {
		if (!dateString?.trim())
			return null;

		const [datePart, timePart] = dateString.trim().split(/\s+/);
		const format = this.userPreferedDateTimeformat;

		if (!format)
			return null;

		const dateSegments = datePart.split(/[-/]/).map(Number);
		if (dateSegments.length !== 3 || dateSegments.some(isNaN)) {
			return null;
		}

		let day: number, month: number, year: number;

		if (format.startsWith('dd/MM')) {
			[day, month, year] = dateSegments;
		} else if (format.startsWith('MM/dd')) {
			[month, day, year] = dateSegments;
		} else if (format.startsWith('yyyy/MM')) {
			[year, month, day] = dateSegments;
		} else {
			return null;
		}

		let hours = 0, minutes = 0, seconds = 0;

		if (timePart) {
			const t = timePart.split(':').map(Number);
			if (t.some(isNaN))
				return null;
			hours = t[0] ?? 0;
			minutes = t[1] ?? 0;
			seconds = t[2] ?? 0;
			if (hours > 23 || minutes > 59 || seconds > 59 || hours < 0 || minutes < 0 || seconds < 0) {
				return null;
			}
		}

		const date = new Date(year, month - 1, day, hours, minutes, seconds);
		return isNaN(date.getTime()) ? null : date;
	} 

  customClear(col: GridColumnHeader): void {
    if (col.advancefilter.isAdvanceFilterUsed) {
      this.clearCall(col);
    }
    this.filters[col.field] = [];
    this.customFilter(col.field);
  }
  
  isSelected(item: any): boolean {
    return this.selectedWorkItems.some(i => i.InstanceId === item.InstanceId);
  }

  copyToClipboard(value: any) {
    if (value !== null && value !== undefined) {
      navigator.clipboard.writeText(value.toString());
      this.commonService.showMessage('Value copied to clipboard.', 'success');
    }
  }

  onRowClick(event: MouseEvent, index: number): void {
    this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
  }

  toggleRowSelection(index: number, ctrlKey: boolean, shiftKey: boolean): void {
    if (!ctrlKey && !shiftKey) {
      this.selectedIndexes = [index];
    }
    else {
      const alreadySelected = this.selectedIndexes.includes(index);
      if (!alreadySelected) {
        this.selectedIndexes.push(index);
      }
      else {
        this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
      }
    }
    this.syncSelectedWorkItems();
  }

  onMouseDown(event: MouseEvent, index: number): void {
    const ctrlKey = event.ctrlKey || event.metaKey;
    const shiftKey = event.shiftKey;
    if (event.button === 0 && !ctrlKey && !shiftKey) {
      this.dragSelecting = true;
      this.selectedIndexes = [index];
      this.syncSelectedWorkItems();
      event.preventDefault();
    }
  }

  onMouseOver(event: MouseEvent, index: number): void {
    if (event.button === 0 && this.dragSelecting && !this.selectedIndexes.includes(index)) {
      this.selectedIndexes.push(index);
      this.syncSelectedWorkItems();
    }
  }

  syncSelectedWorkItems(): void {
    this.selectedWorkItems = this.selectedIndexes
      .filter(i => i >= 0 && i < this.workItems.length)
      .map(i => this.workItems[i]);
  }

  onMouseUp(event: MouseEvent): void {
    if (this.dragSelecting) {
      this.dragSelecting = false;
    }
  }

  onRowKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
    }
  }

  onRowFocus(_event: FocusEvent, _index: number): void {
  }

  exportToExcel(): void {
    try {
      // Convert selected data to worksheet
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.data);

      // Create a new workbook and append the worksheet
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // Generate Excel file
      XLSX.writeFile(wb, 'selected-workitems.xlsx');
      this.commonService.showMessage('File downloaded successfully.', 'success');
    }
    catch (error) {
      this.commonService.showMessage('Error while downloading excel file.', 'error');
    }
  }

  // Method to handle column reordering event
  onColumnReordered(event: any): void {
    if (!this.columns || !Array.isArray(this.columns)) {
      return;
    }
    let columnReordered: any[] = [];
    this.columns = this.columns.map((col, index) => ({
      ...col,
      Order: index + 1
    }));
    this.columns.forEach((col) => {
      columnReordered.push(col.title);
    });
    let reOderedDisplayname = columnReordered.join(" | ");
    this.saveColumnReorderDto = new SaveColumnsReorder();
    this.saveColumnReorderDto.userName = this.globalVariable.getUserGPID;
    this.saveColumnReorderDto.businessAreaId = this.selectedBusinessArea;
    this.saveColumnReorderDto.doctypeId = 0;
    this.saveColumnReorderDto.fieldOrder = 0;
    this.saveColumnReorderDto.gridType = 1; // MyWorkbasket grid type
    this.saveColumnReorderDto.displayName = reOderedDisplayname;
    this.saveColumnReorderDto.wfQueueId = 0;
    this.saveColumnReorderDto.workFlowId = 0;
    this.saveColumnReorderDto.systemId = Number(this.globalVariable.getSelectedSystemId);
    this.commonService.saveUserPreferencesColumns(this.saveColumnReorderDto, 0, this.globalVariable.getUserGPID, Number(this.globalVariable.getSelectedSystemId)).subscribe({
      next: (response) => {
        if (response) {
          this.commonService.showMessage("Saved reordered column for user " + this.globalVariable.getUserGPID, "success");
        }
      },
      error: (error) => {
        this.commonService.showMessage("Error: " + error.error.message + " - Unable to save reordered column for user " + this.globalVariable.getUserGPID + ".", "error");
      }
    });
  }

  showEmailModal(): void {
    if (this.selectedWorkItems.length != 1) {
      return;
    }
    const data = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: this.globalVariable.getSelectedSystemId,
      id: this.selectedWorkItems[0].ReferenceType.toLowerCase() != "po batch" ? this.selectedWorkItems[0].DocumentId : 0,
    };
    this.dialog.open(SendEmailComponent, {
      width: '600px',
      disableClose: true,
      data: data
    });
  }

  copyLink(): void {
    if (this.selectedWorkItems.length != 1) {
      return;
    }
    let message: string = "";
    this.retrievalService.getLink(
      this.globalVariable.getUserGPID,
      this.globalVariable.getSelectedSystemId,
      this.selectedWorkItems[0].DocumentId
    ).subscribe({
      next: (response) => {
        navigator.clipboard.writeText(response).then(() => {
          message = "Link is copied. Link : " + response;
          this.commonService.showMessage(message, 'success');
        }).catch(err => {
          console.error('Failed to copy link: ', err);
        });
      },
      error: (error) => {
        console.error('Not able to fetch the business area', error);
      }
    });
  }

  showLineItemsGLEntry(): void {
    if (!this.selectedWorkItems?.length) return;
    const dialogData = {
      docId: this.selectedWorkItems[0].DocumentId,
      abbyyDocId: this.selectedWorkItems[0].ABBYY_DOCUMENTID,
      abbyyBatchId: this.selectedWorkItems[0].ABBYY_BATCHID,
      isRetrieval: true,
    };
    this.dialog.open(LineItemsGlEntryComponent, {
      width: '85%',
      maxWidth: '100%',
      height: 'auto',
      data: dialogData
    });
  }

  showViewNotes(): void {
    if (this.selectedWorkItems?.length != 1) return;
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const DOCID = this.selectedWorkItems[0].DocumentId;
    const items = this.selectedWorkItems[0].InstanceId;
    const BatchId = this.selectedWorkItems[0].BatchId;
    const dialogData = {
      DocumentId: DOCID,
      userGpid: userGpid,
      systemId: systemId,
      items: items,
      BatchId: BatchId,
      Type: 'viewandadd'
    };
    this.dialog.open(ViewWorkflowNotesComponent, {
      width: '85%',
      height: '600px',
      maxWidth: '100%',
      maxHeight: 'max-content',
      data: dialogData
    });
  }

  showDocumentNotesAdmin(): void {
    if (this.selectedWorkItems?.length != 1) return;
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const DOCID = this.selectedWorkItems[0].DocumentId;
    const dialogData = {
      DocumentId: DOCID,
      userGpid: userGpid,
      systemId: systemId,
      Type: 'view'
    };
    this.dialog.open(ViewAddDocNotesComponent, {
      width: '85%',
      maxWidth: '100%',
      data: dialogData
    });
  }

  showDocumentHistory(): void {
    if (this.selectedWorkItems.length != 1) {
      return;
    }
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const documentId = this.selectedWorkItems[0].DocumentId;
    this.retrievalService.getDocumentHistory(userGpid, systemId, documentId).subscribe({
      next: (response: DocumentHistoryResponse) => {
        const dialogData = {
          documentId: documentId,
          batchId: response.batchId,
          createDate: response.createDate,
          docHistoryDtoList: response.docHistoryDtoList || []
        };
        this.dialog.open(DocumentHistoryDialogComponent, {
          width: '85%',
          height: '1060px',
          maxWidth: '100%',
          maxHeight: 'max-content',
          data: dialogData
        });
      },
      error: (error) => {
        console.error('Not able to fetch the document history:', error);
      }
    });
  }

  showViewHistory(): void {
    if (this.selectedWorkItems.length != 1) {
      return;
    }
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const documentId = this.selectedWorkItems[0].DocumentId;
    this.retrievalService.getWorkflowHistory(userGpid, systemId, documentId).subscribe({
      next: (response: WorkflowHistoryResponse[]) => {
        if (response.length) {
          this.dialog.open(WorkflowHistoryDialogComponent, {
            width: '85%',
            height: '485px',
            maxWidth: '100%',
            maxHeight: 'max-content',
            data: response
          });
        }
      },
      error: (error: any) => {
        console.error('Failed to fetch workflow history:', error);
      }
    });
  }

  assignReleaseWorkItem(tabName: string): void {
    const action = tabName == "RELEASE" ? "Releas" : "Assign";
    const workItemIds: any[] = [];
    this.selectedWorkItems.forEach((item: WorkItem) => {
      workItemIds.push(String(item.InstanceId));
    });
    const postObj = new ReAssignReleaseDto();
    postObj.systemId = Number(this.globalVariable.getSelectedSystemId);
    postObj.userGpid = this.globalVariable.getUserGPID;
    postObj.workItemId = workItemIds;
    postObj.queueId = tabName == "RELEASE" ? 0 : this.selectedWorkItems[0].QueueId;
    postObj.workFlowId = tabName == "RELEASE" ? 0 : this.selectedWorkItems[0].WorkflowId;
    postObj.owningUser = "";
    postObj.assignUserGpid = tabName == "RELEASE" ? "*" : tabName;
    this.commonService.assignReleaseWorkItemWorkFlow(postObj).subscribe({
      next: (response) => {
        this.commonService.showMessage(action + "ing WorkItem Completed Successfully!", "success");
        console.log(action + "ing  WorkItem WorkFlow Completed Successfully!", response);
        this.refreshWorkItem();
      },
      error: (error) => {
        this.commonService.openErrorDialog("Error while " + action + "ing the workitem. Please retry again.");
        this.commonService.showMessage("Error while " + action + "ing work items.", "error");
        console.log(action + "ing WorkItem WorkFlow Failed!" + error.error);
      }
    });
  }

  setDropDown(eventName: any, $event: MouseEvent): void {
    this.openUserSystemDialog(eventName);
  }

  refreshWorkItem(): void {
    this.selectedWorkItems = [];
    this.getMyWorkItemBasketDetails();
  }

  openUserSystemDialog(tabName: string): void {
    if (this.selectedWorkItems.length != 1) {
      return;
    }
    const dialogRef = this.dialog.open(UserReassignComponent, {
      width: '500px',
      height: '200px',
      data: { tabfunction: tabName, selectedRows: this.selectedWorkItems, queueID: this.selectedWorkItems[0].QueueId, workflowID: this.selectedWorkItems[0].WorkflowId } // if you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.refreshWorkItem();
    });
  }

  downloadWorkItem(): void {
    if (this.selectedWorkItems.length != 1) {
      return;
    }
    this.commonService.getDocumentsLinkInfo(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId, this.selectedWorkItems[0].DocumentId).subscribe({
      next: (response: any) => {
        this.documentInfo = response;
        this.workItemService.downloadWorkItem(this.selectedWorkItems[0].DocumentId).subscribe({
          next: (response: any) => {
            const rawUrl = String(response);
            const updatedUrl = rawUrl.replace(environment.apiBaseUrl, environment.siteUrl);
            window.open(updatedUrl + '/' + this.documentInfo[0].imageId);
          },
          error: (error: any) => {
            this.commonService.showMessage("Error in loading download link.", "error");
          }
        });
      },
      error: (error: any) => {
        console.error("Error while documentInfo.", error);
      }
    });
  }

  openDocument(url: string, event: MouseEvent) {
    event.preventDefault();
    const tabName = 'document_tab_' + btoa(encodeURIComponent(url)); // unique per URL
    const win = window.open(url, tabName);
    if (win) {
      win.focus();
    }
  }

  handleRightClick(event: MouseEvent) {
    event.preventDefault();
    this.commonService.openErrorDialog('Right click is disabled for this action. Please navigate using left mouse click.');
  }

  //Handling disable or enable buttons
  documentNotesDisable(): boolean {
    if (this.selectedWorkItems.length != 1) {
      this.isDocumentNotesDisable = true;
    }
    else {
      this.isDocumentNotesDisable = false;
    }
    return this.isDocumentNotesDisable;
  }

  workflowNotesDisable(): boolean {
    if (this.selectedWorkItems.length != 1) {
      this.isWorkflowNotesDisable = true;
    }
    else {
      this.isWorkflowNotesDisable = false;
    }
    return this.isWorkflowNotesDisable;
  }

  documentHistoryDisable(): boolean {
    if (this.selectedWorkItems.length != 1) {
      this.isDocumentHistoryDisable = true;
    }
    else {
      this.isDocumentHistoryDisable = false;
    }
    return this.isDocumentHistoryDisable;
  }

  workflowHistoryDisable(): boolean {
    if (this.selectedWorkItems.length != 1) {
      this.isWorkflowHistoryDisable = true;
    }
    else {
      this.isWorkflowHistoryDisable = false;
    }
    return this.isWorkflowHistoryDisable;
  }

  linkDisable(): boolean {
    if (this.selectedWorkItems.length != 1) {
      this.isLinkDisable = true;
    }
    else {
      this.isLinkDisable = false;
    }
    return this.isLinkDisable;
  }

  emailDisable(): boolean {
    if (this.selectedWorkItems.length != 1) {
      this.isEmailDisable = true;
    }
    else {
      this.isEmailDisable = false;
    }
    return this.isEmailDisable;
  }

  printDisable(): boolean {
    if (this.selectedWorkItems.length != 1) {
      this.isPrintDisable = true;
    }
    else {
      this.isPrintDisable = false;
    }
    return this.isPrintDisable;
  }

  releaseDisable(): boolean {
    if (this.selectedWorkItems.length >= 1) {
      this.isReleaseDisable = !AppContext.userDetails.canRelease;
    } else {
      this.isReleaseDisable = true;
    }
    return this.isReleaseDisable;
  }

  reAssignDisable(): boolean {
    if (this.selectedWorkItems.length != 1) {
      this.isReAssignDisable = true;
    }
    else {
      this.isReAssignDisable = !AppContext.userDetails.canReAssign;
    }
    return this.isReAssignDisable;
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }

  applyCall(col: GridColumnHeader, filterCallback: any, filterRef: any): void {
    col.advancefilter.isAdvanceFilterUsed = true;
    this.applyAdvancedFilter(col);
    filterRef.hide();
  }

  applyAdvancedFilter(col: GridColumnHeader): void {
    const field = col.field;
    const filterMeta = col.advancefilter;

    // Skip filtering if no constraints or filter not enabled
    if (!filterMeta?.isAdvanceFilterUsed || !filterMeta.constraints?.length) {
      return;
    }

    const constraints = filterMeta.constraints;
    const lastConstraint = constraints[constraints.length - 1];

    const operator = !lastConstraint || lastConstraint.value === null || lastConstraint.value === '' ? 'or' : filterMeta.operator || 'or';
    this.workItems = this.workItems.filter(row => {
      const rowValue = (row as any)[field];
      const results = constraints.map(constraint => {
        const filterValue = constraint.value;
        const matchMode = constraint.matchMode;

        // Normalize values
        const stringValue = rowValue?.toString()?.toLowerCase?.();
        const filterString = filterValue?.toString()?.toLowerCase?.();

        switch (matchMode) {
          // String-based logic
          case 'eq':
            return stringValue === filterString;
          case 'startswith':
            return stringValue?.startsWith(filterString);
          case 'contains':
            return stringValue?.includes(filterString);
          case 'doesnotcontain':
            return !stringValue?.includes(filterString);
          case 'endswith':
            return stringValue?.endsWith(filterString);

          // Date/number logic
          case 'gt':
            return new Date(rowValue) > new Date(filterValue);
          case 'gte':
            return new Date(rowValue) >= new Date(filterValue);
          case 'lt':
            return new Date(rowValue) < new Date(filterValue);
          case 'lte':
            return new Date(rowValue) <= new Date(filterValue);

          // Null checks
          case 'isnull':
            return rowValue == null || rowValue === '';
          case 'isnotnull':
            return rowValue != null && rowValue !== '';

          default:
            return true;
        }
      });

      // Combine with AND/OR operator
      return operator === 'or' ? results.some(r => r) : results.every(r => r);
    });
  }

  clearCall(col: GridColumnHeader, filterCallback?: any, filterRef?: any): void {
    col.advancefilter.isAdvanceFilterUsed = false;
    col.advancefilter.constraints.forEach((c: ConstraintsModel) => {
      c.value = '';
    });
    this.workItems = this.data;
    if (filterCallback && filterRef) {
      filterCallback(null); filterRef.hide();
    }
  }

  onDateRuleChange(event: any, field: string, index: number): void {
    const value = event ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].value = value;
    }
  }

  onRuleChange(event: any, field: string, index: number): void {
    const value = typeof event === 'string' ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].value = value;
    }
  }

  onMatchModeChange(event: any, field: string, index: number): void {
    const mode = typeof event === 'string' ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].matchMode = mode;
    }
  }

  onOperatorChange(event: any, field: string): void {
    const operator = typeof event === 'string' ? event : event.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.operator = operator;
    }
  }
}